const Style = {

  input: `float-left relative w-6 h-6 cursor-pointer mr-2 bg-none 
  border border-solid border-slate-300 bg-center appearance-none
  checked:bg-[url('components/form/checkbox/icons/ico-check-white.svg')] 
  checked:bg-green-500 checked:bg-[length:10px] p-1 disabled:opacity-40`,
  label: 'cursor-pointer mt-px normal-case'

}

export default Style;